/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  creatCompany.ts
 * @Package :
 * @author:飞算科技
 * @date:   2022/1/19 11:32
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 飞算科技
 * 注意：本内容仅限于飞算数智科技（深圳）有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */

import {axiosAPIUrl, Parameter} from "./index";
import {LoginReturnDataDto} from "@/utils/h5ToApp";

//新增公司信息
export class CreatCompanyInfo{
    /* 公司名称 */
    companyName: string;
    /* 行业 */
    industryId: string;
    /* 职务 */
    postInfo: string;
    /* 企业规模 */
    dimensionsId: string;
    /*注册类型(1-本人注册,2-代客注册) */
    companyType:string;
    /*公司唯一独立编码（例：feisuan） */
    companyCode:string;
}

//公司信息
export class CompanyInfo{
    /* 公司编号 */
    companyId: string;
    /* 公司名称 */
    companyName: string;
    /* 公司logo */
    logoUrl: string;
    /* 登录账户名 */
    loginName: string;
    /* 用户编号 */
    userId: string;
    /* 距离到期失效 */
    trial?:number;
    /* 合作方id */
    partnerCompanyId?:string;
    /* 公司唯一独立编号 */
    companyCode?:string;
    /* 是否过期 */
    isExpiration?:number;
    /* 当前版本 */
    currentVersion?:string;
    /* 合作方邀请码 */
    versionCode?:string;
    /* 企业是否实名 */
    isIdentification?:string;
    /* 到期时间 */
    expirationTime?:string
    /* 用户类型（0普通，1.超级管理员，2.股东）*/
    userOtherType?:string
}


/**
 * 新增公司
 * @param parameter
 */
export function addCompany(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<CompanyInfo>>({
        url: "/cykjoperation/companyManage/addCompany",
        method: "post",
        data: parameter,
    });
}

/**
 * 获取公司列表
 * @param parameter
 */
 export function getCompanyList(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjoperation/companyQuery/getCompanyList",
        method: "post",
        data: parameter,
    });
}

/**
 * 切换用户账户级别
 * @param parameter
 */
 export function chooseUserType(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<LoginReturnDataDto>>({
        url: "/cykjusercenter/Company/server/chooseUserType",
        method: "post",
        data: parameter,
    });
}

// 判断是否可解除绑定
export function checkUnbindable (parameter: Parameter = {}) {
  return axiosAPIUrl<any>({
    url: '/cykjmerchantsborrower/companyConfigInformationManagement/checkUnbindable',
    method: 'get',
    params: parameter
  })
}

/**
 * 解除绑定获取验证码
 * @param parameter
 */
 export function getSmsCodeByRemoveMobile(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response<{ businessId?: string }>>({
        url: "/cykjusercenter/usermanagement/web/getSmsCodeByremoveMobile",
        method: "post",
        data: parameter,
    });
}

/**
 * 解除绑定
 * @param parameter
 */
 export function removeMobile(parameter: Parameter = {}) {
    return axiosAPIUrl<Ajax.Response>({
        url: "/cykjusercenter/usermanagement/web/removeMobile",
        method: "post",
        data: parameter,
    });
}


/**
 * 新增合作方公司
 * @param parameter
 */
export function addPartnerCompany(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<CompanyInfo>>({
    url: "/cykjoperation/companyManage/addPartnerCompany",
    method: "post",
    data: parameter,
  });
}


